export default __webpack_public_path__ + "static/media/fixture1_boxwin.e9416fcb.png";